import React from 'react';
import MaterialText from '@material-ui/core/TextField';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: 200,
    },
  },
}));

const TextCustom = (props) => {
  const [inputValue, setInputValue] = React.useState(props.value);
  const {
    id = '',
    label = '',
    defaultValue = '',
    helperText = '',
    variant = undefined,
    value = inputValue,
    onChange = setInputValue,
    ...rest
  } = props;
  const classes = useStyles();
  //@todo @umer We need to add one variant for whole project

  return (
    <MaterialText
      id={id}
      label={label}
      defaultValue={defaultValue}
      onChange={onChange}
      value={value}
      helperText={helperText}
      variant={variant}
      {...rest}
    />
  );
};

export default TextCustom;
